'use client';

import { Display, Reveal, GlassCard } from '../ui';

// TODO(stats): "99% AI Accuracy" is not a measured product metric — confirm or
// replace before launch. Other figures are README performance targets.
const stats = [
  { v: '2k+', l: 'Clips / Library' },
  { v: '<1s', l: 'Search Speed' },
  { v: '99%', l: 'AI Accuracy' },
  { v: 'Zero', l: 'Manual Tagging' },
];

export default function ScaleSection() {
  return (
    <section className="relative overflow-hidden bg-mk-void px-6 py-28">
      <div className="relative z-10 mx-auto max-w-[1280px] text-center">
        <Reveal>
          <Display className="mb-6 text-6xl sm:text-7xl md:text-8xl">
            2,000+ Clips. Zero Lag.
          </Display>
          <p className="mx-auto mb-12 max-w-2xl font-mk-body text-lg text-mk-muted">
            Reclipt handles the heavy lifting so your library stays organized, no
            matter how fast you grow. Built for scale, ready for enterprise.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {stats.map((s, i) => (
            <Reveal key={s.l} delay={i * 0.06}>
              <GlassCard className="p-8">
                <p className="font-mk-display text-5xl text-mk-pink">{s.v}</p>
                <p className="mt-2 font-mk-label text-xs font-bold uppercase tracking-[0.1em] text-mk-muted">
                  {s.l}
                </p>
              </GlassCard>
            </Reveal>
          ))}
        </div>
      </div>

      {/* decorative neon scan lines */}
      <div
        className="pointer-events-none absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            'linear-gradient(0deg, transparent 24%, rgba(225,29,72,0.2) 25%, rgba(225,29,72,0.2) 26%, transparent 27%, transparent 74%, rgba(225,29,72,0.2) 75%, rgba(225,29,72,0.2) 76%, transparent 77%, transparent)',
          backgroundSize: '50px 50px',
        }}
      />
    </section>
  );
}
